import { ButtonBase, Menu, styled } from "@mui/material";
import { Typography } from "components/Typography";
import { useMenu } from "hooks/useMenu";
import MuiMenuItem from "@mui/material/MenuItem";
import { ChevronArrowDownIcon } from "components/Icons";

const MenuItem = styled(MuiMenuItem)(() => ({
  fontSize: "12px",
}));

const BANK_SRC = "bank";
const BUSINESS_SRC = "business";

export const DATA_SOURCE_TYPES = {
  [BANK_SRC]: BANK_SRC,
  [BUSINESS_SRC]: BUSINESS_SRC,
};

export const DATA_SOURCE_OPTIONS = {
  [DATA_SOURCE_TYPES.bank]: "Bank",
  [DATA_SOURCE_TYPES.business]: "Business",
};

export const SourceFilter = ({ onSourceChange, selectedSource }) => {
  const { anchorEl, handleClose, handleOpen, open } = useMenu();

  const buttonLabel = DATA_SOURCE_OPTIONS[selectedSource];

  const handleSourceSelect = (source) => {
    onSourceChange(source);
    handleClose();
  };

  return (
    <>
      <ButtonBase
        onClick={handleOpen}
        disableRipple
        sx={{
          display: "flex",
          alignItems: "center",
          columnGap: "8px",
          border: "1px solid #EBEDEF",
          borderRadius: "8px",
          padding: "8px 15px",
        }}
      >
        <Typography variant="notification">{buttonLabel}</Typography>
        <ChevronArrowDownIcon
          sx={{ color: "#8E95A4", fontSize: "14px", marginLeft: "5px" }}
        />
      </ButtonBase>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {Object.entries(DATA_SOURCE_OPTIONS).map(([value, label]) => (
          <MenuItem key={value} onClick={() => handleSourceSelect(value)}>
            {label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
